import React from "react";
import { Modal, Button, Container, Card, Spinner } from "react-bootstrap";

const MessagePopUp = ({ show, handleClose, buttonText, title, textBody, onClickButton, cancelButtonText, onClickCancelButton, loading = false }) => {

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
      >
        <Modal.Body className="popup-after-action-modal-body">
          <Container>
            <Card className="mx-auto p-3 rounded-border-px custom-shadow">
              <Card.Body className="d-flex flex-column align-items-center">
                <p className="modal-title mt-2">{title}</p>
                {/* Renderizar el textBody dependiendo de si es texto o JSX */}
                {typeof textBody === "string" ? (
                  <p className="mt-2 text-justify" dangerouslySetInnerHTML={{ __html: textBody }}></p>
                ) : (
                  <div className="mt-2 text-justify">
                    {textBody}
                  </div>
                )}
                <div className="text-center mt-auto d-flex justify-content-between">
                  {cancelButtonText && onClickCancelButton &&
                    <Button
                      type="submit"
                      className="w-100 mt-2 me-5 custom-button-secondary custom-bg-secondary"
                      onClick={onClickCancelButton}
                      disabled={loading}
                    >
                      {cancelButtonText}
                    </Button>}
                  <Button
                    type="submit"
                    className="w-100 mt-2 custom-button-primary custom-bg-primary"
                    onClick={onClickButton}
                    disabled={loading}
                  >
                    {loading ? <Spinner animation="border" size="sm" /> : buttonText}
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default MessagePopUp;